import gql from 'graphql-tag'

export const GET_REUSE = gql`
query(
  $page:Int!
  $perPage:Int!
  $type:String!
  $search:String
){
  getReuse(type:$type page:$page perPage:$perPage search:$search){
    reuseType{
      _id
      name
      laoName
      enName
      jobs
      emps
      score
    }
    totals
    jobCheck
    empCheck
  }
}
`
export const REUSE = gql`
query(
  $type:String!
){
  getReuses(type:$type){
    _id
    name
    enName
    laoName
    score
  }
}
`
export const SORT = gql`
mutation(
  $type: String
  $items: [ID]
){
  sortReuse(info:{type: $type, items:$items})
}
`

